/**
 * Builds & Returns Default Style Object for `react-select`
 * @function getDefaultStyles
 * @param {Object} styleObj
 * @param {Object} data
 * @return {Object}
 */
export default () => ({
  container: (styleObj, { data, isDisabled, isFocused, isSelected }) => {
    return {
      ...styleObj,
      borderRadius: '4px',
      outline: 'none',
      transition: '0.5s all ease-in-out',
      ':focus': {
        border: '1px solid #105EEB',
        boxShadow: '0 0 4px 0 rgba(16,94,235,0.5)',
      },
    };
  },
  control: styleObj => ({ ...styleObj, backgroundColor: '#FFFFFF' }),
  input: styleObj => ({ ...styleObj, fontFamily: 'Proxima Nova', fontSize: '14px' }),
  menu: styleObj => ({ ...styleObj, marginTop: '1px' }),
  option: (styleObj, { data, isDisabled, isFocused, isSelected }) => {
    return {
      ...styleObj,
      backgroundColor: isDisabled ? '#E8F0FE' : '#FFF',
      color: '#041D45',
      fontFamily: 'Proxima Nova',
      fontSize: '14px',
      ':hover': {
        backgroundColor: '#F4F8FE',
        cursor: 'pointer',
      },
    };
  },
  placeholder: styleObj => ({ ...styleObj, color: '#AFC1E1', fontFamily: 'Proxima Nova', fontSize: '14px' }),
  singleValue: styleObj => ({ ...styleObj, fontFamily: 'Proxima Nova', fontSize: '14px' }),
});
